import React, { Fragment } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import { buildPath, packClasses } from "Utils";

// export function locationDecorator(Component) {
//     const location = useLocation();
//     const { basePath, ...useProps } = props;

//     return (
//         <Pagination
//             basePath={basePath ? basePath : location.pathname}
//             {...useProps}
//         />
//     );
// }

export default function Pagination(props) {
    const activeClasses =
        "z-0 border-gray-300 text-green-600 relative items-center px-4 py-2 border text-sm font-medium";
    const defaultClasses =
        "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative items-center px-4 py-2 border text-sm font-medium";

    const clickHandler = (meta, e) => {
        if (props.onClick) {
            props.onClick(meta);
        }
        if (props.onPageChange) {
            props.onPageChange(meta);
        }
    };

    const variants = {
        sm: "px-2 py-2 md:text-sm font-medium",
        xs: "px-1 text-sm md:text-xs font-medium leading-3",
    };
    const variant = props.variant ? props.variant : "sm";

    if (!props.total_pages) {
        return (
            <div className="items-center justify-between">
                <div className="flex flex-1 justify-between">
                    <div className="mx-auto h-8 w-1/2 rounded-md bg-gray-200">
                        &nbsp;
                    </div>
                </div>
            </div>
        );
    }

    let max = props.total_pages;
    const maxPages = props.maxPages || 10;
    let start = 1;
    if (max > maxPages) {
        if (props.current_page > maxPages / 2) {
            start = props.current_page - Math.ceil(maxPages / 2);
        }

        max = start + maxPages;
        if (props.total_pages <= maxPages || max > props.total_pages) {
            max = props.total_pages;
        }
    }

    let pages = [];
    for (let i = start; i <= max; i++) {
        if (props.basePath) {
            pages.push(
                <Link
                    key={"page".concat(i)}
                    to={buildPath(props.basePath, { page: i }, true)}
                    aria-current={props.current_page === i ? "page" : ""}
                    className={packClasses(
                        variants[variant],
                        props.current_page === i
                            ? activeClasses
                            : defaultClasses,
                        "hidden md:inline-flex"
                    )}
                    onClick={() => {
                        if (props.onPageChange) {
                            props.onPageChange();
                        }
                    }}
                >
                    {i}
                    <span
                        aria-hidden="true"
                        className={packClasses(
                            props.current_page === i
                                ? "bg-green-500"
                                : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5",
                            "hidden md:inline-flex"
                        )}
                    />
                </Link>
            );
        } else {
            pages.push(
                <span
                    key={"page".concat(i)}
                    onClick={clickHandler.bind(null, { page: i })}
                    aria-current={props.current_page === i ? "page" : ""}
                    className={packClasses(
                        variants[variant],
                        "cursor-pointer",
                        props.current_page === i
                            ? activeClasses
                            : defaultClasses,
                        "hidden md:inline-flex"
                    )}
                >
                    {i}
                    <span
                        aria-hidden="true"
                        className={packClasses(
                            props.current_page === i
                                ? "bg-green-500"
                                : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5",
                            "'hidden md:inline-flex"
                        )}
                    />
                </span>
            );
        }
    }

    return (
        <div className="flex items-center justify-center sm:justify-between">
            <div className="sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div className="mx-auto">
                    <nav
                        className="relative z-0 inline-flex -space-x-px rounded-md shadow-sm"
                        aria-label="Pagination"
                    >
                        {props.current_page > 1 ? (
                            <Fragment>
                                {props.basePath ? (
                                    <Link
                                        to={buildPath(
                                            props.basePath,
                                            {
                                                page: props.current_page - 1,
                                            },
                                            true
                                        )}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white  text-gray-500 hover:bg-gray-50"
                                        )}
                                        onClick={() => {
                                            if (props.onPageChange) {
                                                props.onPageChange();
                                            }
                                        }}
                                    >
                                        <span className="sr-only">
                                            Previous
                                        </span>
                                        <ChevronLeftIcon
                                            className="h-8 w-8 md:h-5 md:w-5"
                                            aria-hidden="true"
                                        />
                                    </Link>
                                ) : (
                                    <span
                                        onClick={clickHandler.bind(null, {
                                            page: props.current_page - 1,
                                        })}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex cursor-pointer items-center rounded-l-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">
                                            Previous
                                        </span>
                                        <ChevronLeftIcon
                                            className="h-8 w-8 md:h-5 md:w-5"
                                            aria-hidden="true"
                                        />
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            <span
                                className={packClasses(
                                    variants[variant],
                                    "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white text-gray-300 hover:bg-gray-50"
                                )}
                            >
                                <span className="sr-only">Previous</span>
                                <ChevronLeftIcon
                                    className="h-8 w-8 md:h-5 md:w-5"
                                    aria-hidden="true"
                                />
                            </span>
                        )}

                        {!props.paginationStyle ||
                        props.paginationStyle !== "lr-only"
                            ? pages
                            : null}

                        {props.current_page < props.total_pages ? (
                            <Fragment>
                                {props.basePath ? (
                                    <Link
                                        to={buildPath(
                                            props.basePath,
                                            {
                                                page: props.current_page + 1,
                                            },
                                            true
                                        )}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white  text-gray-500 hover:bg-gray-50"
                                        )}
                                        onClick={() => {
                                            if (props.onPageChange) {
                                                props.onPageChange();
                                            }
                                        }}
                                    >
                                        <span className="sr-only">Next</span>
                                        <ChevronRightIcon
                                            className="h-8 w-8 md:h-5 md:w-5"
                                            aria-hidden="true"
                                        />
                                    </Link>
                                ) : (
                                    <span
                                        onClick={clickHandler.bind(null, {
                                            page: props.current_page + 1,
                                        })}
                                        className={packClasses(
                                            variants[variant],
                                            "relative inline-flex cursor-pointer items-center rounded-r-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50"
                                        )}
                                    >
                                        <span className="sr-only">Next</span>
                                        <ChevronRightIcon
                                            className="h-8 w-8 md:h-5 md:w-5"
                                            aria-hidden="true"
                                        />
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            <span
                                className={packClasses(
                                    variants[variant],
                                    "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white text-gray-300 hover:bg-gray-50"
                                )}
                            >
                                <span className="sr-only">Next</span>
                                <ChevronRightIcon
                                    className="h-8 w-8 md:h-5 md:w-5"
                                    aria-hidden="true"
                                />
                            </span>
                        )}
                    </nav>
                </div>
            </div>
        </div>
    );
}
